
import React from 'react';

const CredentialsSection = () => {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          <img 
            src="/lovable-uploads/6f9e2350-98ed-48f2-88b8-40f2c3e8147a.png" 
            alt="Lessons.com Top Pro Awards" 
            className="w-32 h-32 object-contain animate-fade-up"
          />
          <img 
            src="/lovable-uploads/e21dada4-abbd-4697-8dee-8e005de581bf.png" 
            alt="USA Basketball Logo" 
            className="w-32 h-32 object-contain animate-fade-up"
          />
          <img 
            src="/lovable-uploads/4dcc8354-e0b1-4b32-88fe-057f5cec08df.png" 
            alt="FIBA Logo" 
            className="w-48 h-32 object-contain animate-fade-up"
          />
          <img 
            src="/lovable-uploads/46752a43-e9b5-489e-a220-839dc567773c.png" 
            alt="WBDA Logo" 
            className="w-48 h-48 object-contain animate-fade-up"
          />
        </div>
      </div>
    </div>
  );
};

export default CredentialsSection;
